
import { NavLink } from "react-router-dom";
import TwoImageCarousel from "../Component/Carousel"; 
export default function Home() {
  return (
    <div className="home">

      {/* Hero Carousel */}
      <TwoImageCarousel  />

      {/* ABOUT US */}
      <section className="section">
        <h3>ABOUT US</h3>
        <p>
          We’re Plus Credit, your go-to for credit and investment solutions that just work.
          We partner with top brands and platforms to deliver seamless, digital-first financial products from saving smarter to shopping better.
          Whether you’re leveling up your phone, funding a trip, or stacking your savings, we plug you into the money moves that matter.
        </p>
      </section>

      {/* PRODUCTS */}
      <section className="section">
        <h3 className="homesecond">PRODUCTS</h3>
        <p>We offer a wide range of products:</p>

        <div className="productst">
          <div className="product">
            <h4>BANKVOLE</h4>
            <p>Save, invest, and grow with BankVole today.</p>
          </div>

          <div className="productt">
            <h4>TRAVELMONI</h4>
            <p>Proof of funds for travel? We've got you covered.</p>
          </div>

          <div className="product">
            <h4>SMARTPAY</h4>
            <p>Buy Samsung devices in easy installments.</p>
          </div>

          <div className="productt">
            <h4>FX-FD</h4>
            <p>Secure dollar investments with high returns.</p>
          </div>
        </div>

        <NavLink to="/products" className="a">
          Learn More
        </NavLink>
      </section>

      {/* AFFILIATE */}
      <section className="section">
        <h3 className="homesecond">AFFILIATE</h3>
        <p className="p">
          Our affiliate community is full of creators, innovators, and genuine heroes helping people access legit financial tools and getting paid for it.
        </p>
        <NavLink to="/affiliate" className="a">
          Learn More
        </NavLink>
      </section>

      {/* CONTACT US */}
      <section className="section">
        <h3 className="homesecond">CONTACT US</h3>
        <p className="p">
          The affiliate email address is <a href="mailto:affiliate@pluscredit.systems" className="email">affiliate@pluscredit.systems</a>.
          The contact number is <span className="number">09168344191</span>.
        </p>
        <NavLink to="/contactus" className="a">
          Learn More
        </NavLink>
      </section>
    </div>
  );
}
